export const muiThemeComponents = {
  MuiTypography: {
    styleOverrides: {
      root: {
        fontSize: 'x-large',
      },
      overline: {
        fontSize: 'inherit',
      },
    },
  },
  PrivatePickersYear: {
    styleOverrides: {
      button: {
        fontSize: 'inherit',
      },
    },
  },
  MuiDayPicker: {
    styleOverrides: {
      weekDayLabel: {
        fontSize: 'inherit',
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        fontSize: 'inherit',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: 'x-large',
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: 'x-large',
      },
    },
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: 'large',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: 'initial',
      },
    },
  },
  MuiDateTimePickerToolbar: {
    styleOverrides: {
      timeContainer: {
        alignItems: 'center',
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      content: {
        justifyContent: 'space-evenly',
        alignItems: 'center',
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      switchViewIcon: {
        fontSize: 'inherit',
      },
      labelContainer: {
        fontSize: 'inherit',
      },
    },
  },
};
